export default (num, digit) => {
    return (num % 1) === 0 ? num.toFixed(0) : num.toFixed(digit);
};
